<template>
  <div class="create-cartography-make-ui">
    <div class="left-panel">
      <div class="create-item" @click="handleCreate">
        <img class="create-icon" src="img/create-file.png" alt="新建图纸文件" />
        <div class="create-label">新建图纸文件</div>
      </div>
    </div>
    <div class="right-panel">
      <img class="main-image" src="img/cartography-demo.jpg" alt="制图示例" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateCartographyMake',
  methods: {
    handleCreate() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: '正在启动 GoodLaser 软件，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      try {
        const newWindow = window.open('GoodLaser://launch?foreground=true', '_blank');
        if (newWindow) {
          newWindow.focus();
        }
      } catch (error) {
        console.error('启动失败:', error);
        this.$message.error('启动失败，请手动打开 GoodLaser');
      } finally {
        setTimeout(() => {
          if (this.loadingInstance) {
            this.loadingInstance.close();
          }
        }, 3000);
      }
    },
  },
};
</script>

<style scoped>
.create-cartography-make-ui {
  display: flex;
  background: #f7fbfe;
  border-radius: 16px;
  padding: 24px 24px;
  min-height: 420px;
}
.left-panel {
  width: 260px;
  background: #f0f7fd;
  border-radius: 12px;
  margin-right: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 350px;
  border: 2px dashed #b5d6f6;
}
.create-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0 40px 0;
  width: 100%;
  cursor: pointer;
  
  border-radius: 10px;
  background: #eaf5fd;
  transition: box-shadow 0.2s, border-color 0.2s;
}
.create-item:hover {
  box-shadow: 0 4px 18px rgba(46,162,250,0.08);
  border-color: #2ea2fa;
}
.create-icon {
  width: 56px;
  height: 56px;
  margin-bottom: 12px;
}
.create-label {
  font-size: 18px;
  color: #222;
  font-weight: 500;
}
.right-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 12px;
  min-height: 350px;
  overflow: hidden;
}
.main-image {
  max-width: 100%;
  max-height: 780px;
  border-radius: 12px;
  object-fit: cover;
}
@media (max-width: 900px) {
  .create-cartography-make-ui {
    flex-direction: column;
    padding: 16px 8px;
  }
  .left-panel {
    width: 100%;
    margin-right: 0;
    margin-bottom: 18px;
    min-height: 120px;
  }
  .right-panel {
    min-height: 120px;
  }
}
</style>
